import { useRef } from 'react';

interface BodyStyleSnapshot {
    bodyPosition: string;
    bodyOverflow: string;
    bodyWidth: string;
}

/**
 * Saves and restores body/html scroll-related inline styles.
 *
 * Why: third-party scripts (e.g. WNSTN widget) lock scroll on mobile by setting
 * position:fixed + overflow:hidden + width:100% on document.body. Removing the
 * script from the DOM does not revert those inline styles, so callers must do it
 * explicitly.
 */
export const useBodyStyleRestore = () => {
    const snapshotRef = useRef<BodyStyleSnapshot | null>(null);

    const saveBodyStyles = () => {
        snapshotRef.current = {
            bodyPosition: document.body.style.position,
            bodyOverflow: document.body.style.overflow,
            bodyWidth: document.body.style.width,
        };
    };

    const restoreBodyStyles = () => {
        const s = snapshotRef.current;
        if (!s) return;

        document.body.style.position = s.bodyPosition;
        document.body.style.overflow = s.bodyOverflow;
        document.body.style.width = s.bodyWidth;
        snapshotRef.current = null;
    };

    return { saveBodyStyles, restoreBodyStyles };
};
